"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect, useRef, useCallback } from "react";
interface ScrollDirectionState {
  /** True when user is actively scrolling down */
  readonly isScrollingDown: boolean;
}
const SCROLL_THRESHOLD = 15;
const SCROLL_STOP_DELAY_DESKTOP = 200;
const SCROLL_STOP_DELAY_MOBILE = 400;

/**
 * Detects scroll direction on the main content scroll container.
 * Looks for `[data-scroll-container]` in the DOM (added to DashboardLayout <main>).
 * Falls back to window if not found (CoreLayout pages — FABs stay visible).
 */
export function useScrollDirection() {
  const $ = _c(4);
  const [isScrollingDown, setIsScrollingDown] = useState(false);
  const lastScrollTop = useRef(0);
  const stopTimer = useRef(null);
  const isMobile = _temp;
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const scrollEl = document.querySelector("[data-scroll-container]");
      if (!scrollEl) {
        return;
      }
      const handleScroll = function handleScroll() {
        const currentScrollTop = scrollEl.scrollTop;
        const delta = currentScrollTop - lastScrollTop.current;
        if (Math.abs(delta) > SCROLL_THRESHOLD) {
          setIsScrollingDown(delta > 0);
          lastScrollTop.current = currentScrollTop;
        }
        if (stopTimer.current) {
          clearTimeout(stopTimer.current);
        }
        const delay = isMobile() ? SCROLL_STOP_DELAY_MOBILE : SCROLL_STOP_DELAY_DESKTOP;
        stopTimer.current = setTimeout(() => {
          setIsScrollingDown(false);
        }, delay);
      };
      scrollEl.addEventListener("scroll", handleScroll, {
        passive: true
      });
      return () => {
        scrollEl.removeEventListener("scroll", handleScroll);
        if (stopTimer.current) {
          clearTimeout(stopTimer.current);
        }
      };
    };
    t1 = [isMobile];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== isScrollingDown) {
    t2 = {
      isScrollingDown
    };
    $[2] = isScrollingDown;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp() {
  return typeof window !== "undefined" && window.innerWidth < 768;
}